export default __webpack_public_path__ + "static/media/pu3.ab918db5.png";